import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import admin from "../../../containers/modules/user/admin";
import Assignment from "./assignment";
import route from "../../../containers/modules/user/route";
import Permission from "./permission";
import Role from "./role";
import Menu from "../../../containers/modules/user/menu";

export default function AdminRoute(props) {
  const { authUser } = props;
  return (
    <Route path="admin">
      <Route
        index
        element={
          <AccessControl name={"User List"} auth={authUser} component={admin} />
        }
      ></Route>
      <Route
        path="assignment/:id"
        element={
          <AccessControl
            name={"Assignment Show"}
            auth={authUser}
            component={Assignment}
          />
        }
      />
      <Route
        path="route"
        element={
          <AccessControl
            name={"Route Show"}
            auth={authUser}
            component={route}
          />
        }
      />
      <Route path="permission">
        <Route
          index
          element={
            <AccessControl
              name={"Permission List"}
              auth={authUser}
              component={() => <Permission typeUrl={"index"} />}
            />
          }
        />
        <Route
          path="create"
          element={
            <AccessControl
              name={"Permission Create"}
              auth={authUser}
              component={() => <Permission typeUrl={"create"} />}
            />
          }
        />
        <Route
          path="update/:id"
          element={
            <AccessControl
              name={"Permission Update"}
              auth={authUser}
              component={() => <Permission typeUrl={"update"} />}
            />
          }
        />
        <Route
          path="assign/:id"
          element={
            <AccessControl
              name={"Permission Assign"}
              auth={authUser}
              component={() => <Permission typeUrl={"assign"} />}
            />
          }
        />
      </Route>
      <Route path="role">
        <Route
          index
          element={
            <AccessControl
              name={"Role List"}
              auth={authUser}
              component={() => <Role typeUrl={"index"} />}
            />
          }
        />
        <Route
          path="create"
          element={
            <AccessControl
              name={"Role Create"}
              auth={authUser}
              component={() => <Role typeUrl={"create"} />}
            />
          }
        />
        <Route
          path="update/:id"
          element={
            <AccessControl
              name={"Role Update"}
              auth={authUser}
              component={() => <Role typeUrl={"update"} />}
            />
          }
        />
        <Route
          path="assign/:id"
          element={
            <AccessControl
              name={"Role Assign"}
              auth={authUser}
              component={() => <Role typeUrl={"assign"} />}
            />
          }
        />
      </Route>
      <Route path="menu">
        <Route
          index
          element={
            <AccessControl
              name={"Route Show"}
              auth={authUser}
              component={() => <Menu />}
            />
          }
        />
      </Route>
    </Route>
  );
}
